import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderComp from '../Header/Header';
import './myFavoriteTehilim.css';
import { numberToHebrew } from '../../Functions/LetterToNum';
import utils from '../../Functions/utils';

import Swal from 'sweetalert2';

function FavoriteTehilimComp() {
  const [userData, setUserData] = useState({});
  const [selectedChapters, setSelectedChapters] = useState([]);
  const [menuHeaderOpen, setMenuHeaderOpen] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();


  
  useEffect(() => {
    const fetchData = async () => {
      await fetchSelectedChapters();
    };
    fetchData();
  }, []);

  const fetchSelectedChapters = async () => {
    try {
      const resp = await utils.requestData('GetUserFavorites', {});
      setSelectedChapters(resp.map(x=>x.chapterId));
    } catch (err) {
      console.error('Error fetching selected Chapters:', err);
      setError(err.message);
    }
  };

  const toggleChapter = (chapterNumber) => {
    setSelectedChapters(prev =>
      prev.includes(chapterNumber)
        ? prev.filter(num => num !== chapterNumber)
        : [...prev, chapterNumber]
    );
  };

  const sendFavorites = async (name) => {
    try {
      await utils.requestData('UpdateUserFavorites', {selectedChapters});
      await Swal.fire({
        title: 'פרקי תהילים מועדפים',
        html: `<div>עודכן בהצלחה</div>`,
        icon: 'success',
      });
      navigate("/main")
    } catch (err) {
      console.error('Error donate:', err);
      setError(err.message);
      Swal.fire('שגיאה', err.message, 'error');
    }
  };
    
  
  return (
    <div className="tehilim-selector-container">
      <HeaderComp
        userData={userData}
        menuHeaderOpen={menuHeaderOpen}
        setMenuHeaderOpen={setMenuHeaderOpen}
      />

      <div className="selector-wrapper">
        <h2 className="selector-title">פרקי התהילים המועדפים עליך</h2>

        <div className="chapter-grid">
          {[...Array(150)].map((_, index) => {
            const chapter = index + 1;
            const isSelected = selectedChapters.includes(chapter);
            return (
              <button
                key={chapter}
                className={`chapter-button ${isSelected ? 'selected' : ''}`}
                onClick={() => toggleChapter(chapter)}
              >
              פרק {numberToHebrew(chapter)}
              </button>
            );
          })}
        </div>

        <button className="button save-button" onClick={sendFavorites}>
          💾 שמור מועדפים
        </button>
        <button className="button back-button" onClick={() => navigate("/main")}>
          ⬅ חזור
        </button>
      </div>
    </div>
  );
}

export default FavoriteTehilimComp;
